
<template>
  <div class="privacy">
    <div class="content">
      <header>狸米新启航隐私政策</header>
      <section>
        <p>感谢您选择狸米新启航！</p>
        <p>
        我们非常重视您的个人信息和隐私保护，为了更好的保护您的个人权益，在您使用我们的产品前，请务必审慎阅读
        <i @click.stop="showPolicy">《隐私政策》、</i>
        <i @click.stop="showChildPolicy">《儿童隐私保护政策》</i
        >内的所有条款，同意并接受全部条款后即可开始使用我们的产品和服务。</p>
      </section>
      <footer class="btns">
        <button class="cursor" @click="noAgree">不同意</button>
        <button class="cursor" @click="agree">同意</button>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    agree() {
      this.$emit("agree");
    },
    noAgree() {
      this.$emit("noAgree");
    },
    showPolicy(){
      this.$emit("showPolicy");
    },
    showChildPolicy(){
      this.$emit("showChildPolicy");
    }
  },
};
</script>
<style lang="less" scoped>
.privacy {
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 99;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
}
.content {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 570px;
  height: 415px;
  border-radius: 15px;
  background: #ffffff;
  overflow: hidden;
}
.btns {
  padding: 25px 0;
  button {
    width: 175px;
    height: 60px;
    border-radius: 13px;
    font-size: 22px;
    line-height: 0;
    &:first-child {
      border: 2px solid #008ACF;
      color: #008ACF;
    }
    &:first-child:hover {
      border-color: #0e99df;
      color: #52b7eb;
    }
    &:last-child {
      background: #0099e6;
      color: #ffffff;
      margin-left: 15px;
    }
    &:last-child:hover {
      background: #0095e1;
      color: #99cfeb;
    }
  }
}
header {
  width: 100%;
  height: 67px;
  line-height: 67px;
  background: #0089ce;
  color: #ffffff;
  font-size: 24px;
}
section{
  padding: 25px 45px;
  p{
    padding-top: 15px;
    text-align: left;
    color: #333333;
    font-size: 19px;
    line-height: 30px;
  }
  i{
    cursor: pointer;
    color: #2298d4;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basic/privacy/privacy.vue